export default ownProps => ownProps.match.params;
